<ef-loading [loading]="loadingData"></ef-loading>
<div
    class="card"
    fullscreen
    style="transition: none !important; box-shadow: none !important"
>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>

    <!-- <p-accordion [multiple]="true">
        <p-accordionTab header="Filters" [selected]="true">
            <form
                [formGroup]="filterFormGroup"
                #filterForm="ngForm"
                id="filterForm"
            >
                <p-toolbar>
                    <div style="padding-right: 1vw; padding-left: 1vw">
                        <button
                            pButton
                            pRipple
                            class="p-button-text"
                            label="Refresh"
                            (click)="refreshTable()"
                        ></button>
                    </div>

                    <div
                        *ngIf="jobListStatus as items; else loading"
                        style="padding-right: 1vw"
                    >
                        <p-select
                            [virtualScroll]="true"
                            itemSize="32"
                            #pmg
                            [options]="items"
                            formControlName="jobListStatus"
                            [filter]="true"
                            optionLabel="FilterDesc"
                            dataKey="FilterID"
                            placeholder="{{ this.EntityFilterText }}"
                            appendTo="body"
                        ></p-select>
                    </div>

                    <div
                        *ngIf="filteredCustomers as items; else loading"
                        style="padding-right: 1vw"
                    >
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            [options]="items | orderBy: 'CustomerName'"
                            optionLabel="CustomerName"
                            [filter]="true"
                            selectedItemsLabel="{0} Customer(s) selected."
                            formControlName="customers"
                            [defaultLabel]="this.CustomerFilterText"
                            dataKey="CustomerListID"
                            appendTo="body"
                        >
                        </p-multiSelect>
                    </div>
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion> -->

    <div class="jobs">
        <p-toolbar>
            <div class="ui-toolbar-group-left">
                <div style="justify-content: left; display: flex">
                    <div
                        *ngIf="filteredCustomers as items; else loading"
                        style="padding-right: 1vw"
                    >
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            [options]="items | orderBy: 'CustomerName'"
                            optionLabel="CustomerName"
                            [filter]="true"
                            selectedItemsLabel="{0} Customer(s) selected."
                            (onChange)="customerFilter($event)"
                            [defaultLabel]="this.CustomerFilterText"
                            dataKey="CustomerListID"
                            appendTo="body"
                        >
                        </p-multiSelect>
                    </div>
                    <div style="padding-right: 1vw">
                        <button
                            pButton
                            class="p-button-text"
                            (click)="expandCollapse('expand')"
                            label="Expand All"
                        ></button>
                    </div>

                    <div style="padding-right: 1vw">
                        <button
                            pButton
                            class="p-button-text"
                            (click)="expandCollapse('collapse')"
                            label="Collapse All"
                        ></button>
                    </div>
                    <div style="padding-right: 1vw; padding-left: 1vw">
                        <button
                            pButton
                            pRipple
                            icon="pi pi-refresh"
                            class="p-button-secondary"
                            label="Refresh"
                            (click)="refreshTable()"
                        ></button>
                    </div>
                    <div>
                        <p-splitButton
                            id="download-csv"
                            icon="pi pi-download"
                            pTooltip="Download"
                            styleClass="p-button-secondary"
                            [model]="this.downloadOptions"
                            (onClick)="this.downloadTable('csv')"
                        ></p-splitButton>
                    </div>
                </div>
            </div>
        </p-toolbar>

        <div class="table-container contract-structure-tree">
            <p-treeTable
                [value]="treeNodes"
                [scrollable]="true"
                scrollHeight="68vh"
                dataKey="key"
                [tableStyle]="{ 'min-width': '98rem' }"
                styleClass="table p-datatable-full"
                (onNodeExpand)="onTreeNodeExpand($event)"
                (onNodeCollapse)="onTreeNodeCollapse($event)"
            >
                <ng-template pTemplate="togglericon" let-expanded>
                    <span
                        class="contract-structure-tree-toggler-icon"
                        aria-hidden="true"
                        >{{ expanded ? '−' : '+' }}</span
                    >
                </ng-template>
                <ng-template pTemplate="colgroup">
                    <colgroup>
                        <col style="width: 3rem" />
                        <col style="width: 6rem" />
                        <col/>
                        <col style="width: 8rem"/>
                        <col style="width: 10rem"/>
                        <col/>
                        <col/>
                        <col style="width: 8rem"/>
                        <col style="width: 10rem"/>
                        <col style="width: 10rem"/>
                        <col/>
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th></th>
                        <th>Inactive</th>
                        <th>Customer/Job Name</th>
                        <th>Contract</th>
                        <th>Charge Number</th>
                        <th>Contract Category</th>
                        <th>Contract Type</th>
                        <th>Invoice Level</th>
                        <th>Structure Locked</th>
                        <th>Authorized Users</th>
                        <th>First Process Date</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
                    <tr
                        [ttRow]="rowNode"
                        [ngClass]="{ highlight: isSelectedErrorRow(rowData) }"
                    >
                        <td>
                            <i
                                class="material-icons status-icon"
                                [ngClass]="statusClass(rowData)"
                                [pTooltip]="rowData?.Status?.Message"
                                tooltipPosition="top"
                                [tooltipDisabled]="!rowData?.Status?.Message"
                                (click)="onStatusClick(rowData)"
                                >{{
                                    rowData?.Status?.StatusCode === 1
                                        ? 'check_circle'
                                        : rowData?.Status?.StatusCode === 2
                                          ? 'report_problem'
                                          : rowData?.Status?.StatusCode >= 3 &&
                                              rowData?.Status?.StatusCode <= 6
                                            ? 'highlight_off'
                                            : ''
                                }}</i
                            >
                        </td>
                        <td
                            [pTooltip]="rowData.QB_IsActive === false ? 'X' : ''"
                            tooltipPosition="top"
                            [tooltipDisabled]="rowData.QB_IsActive !== false"
                        >
                            {{ rowData.QB_IsActive === false ? 'X' : '' }}
                        </td>
                        <td
                            [pTooltip]="rowData.QB_Name"
                            tooltipPosition="top"
                            [tooltipDisabled]="!rowData.QB_Name"
                        >
                            <p-treeTableToggler
                                [rowNode]="rowNode"
                            ></p-treeTableToggler>
                            {{ rowData.QB_Name }}
                        </td>
                        <td class="boolean-check-cell">
                            <p-checkbox
                                [binary]="true"
                                [ngModel]="rowData.IsContract"
                                [disabled]="!canToggleContract(rowData)"
                                [pTooltip]="rowData.IsContract ? 'Yes' : 'No'"
                                tooltipPosition="top"
                                (onChange)="toggleContract(rowData)"
                            ></p-checkbox>
                        </td>
                        <td
                            class="boolean-check-cell"
                            [pTooltip]="rowData.IsChargeNumber ? 'Yes' : 'No'"
                            tooltipPosition="top"
                        >
                            <i
                                *ngIf="rowData.IsChargeNumber"
                                class="material-icons text-primary contract-structure-boolean-check"
                                aria-hidden="true"
                                >check</i
                            >
                        </td>
                        <td>
                            <p-select
                                *ngIf="canEditContractCategory(rowData)"
                                [options]="categories"
                                optionLabel="label"
                                optionValue="value"
                                styleClass="w-full"
                                appendTo="body"
                                [ngModel]="rowData.ContractCategory"
                                [pTooltip]="rowData.ContractCategory"
                                tooltipPosition="top"
                                [tooltipDisabled]="!rowData.ContractCategory"
                                (onChange)="
                                    changeContractCategory(rowData, $event.value)
                                "
                            ></p-select>
                            <span
                                *ngIf="!canEditContractCategory(rowData)"
                                [pTooltip]="rowData.ContractCategory"
                                tooltipPosition="top"
                                [tooltipDisabled]="!rowData.ContractCategory"
                                >{{ rowData.ContractCategory }}</span
                            >
                        </td>
                        <td>
                            <p-select
                                *ngIf="canEditContractType(rowData)"
                                [options]="contractTypeOptions()"
                                optionLabel="label"
                                optionValue="value"
                                styleClass="w-full"
                                appendTo="body"
                                [ngModel]="rowData.ContractType"
                                [pTooltip]="contractTypeLabel(rowData.ContractType)"
                                tooltipPosition="top"
                                [tooltipDisabled]="!contractTypeLabel(rowData.ContractType)"
                                (onChange)="
                                    changeContractType(rowData, $event.value)
                                "
                            ></p-select>
                            <span
                                *ngIf="!canEditContractType(rowData)"
                                [pTooltip]="contractTypeLabel(rowData.ContractType)"
                                tooltipPosition="top"
                                [tooltipDisabled]="!contractTypeLabel(rowData.ContractType)"
                                >{{ contractTypeLabel(rowData.ContractType) }}</span
                            >
                        </td>
                        <td class="boolean-check-cell">
                            <p-checkbox
                                [binary]="true"
                                [ngModel]="rowData.IsInvoiceLevel"
                                [disabled]="!canToggleInvoiceLevel(rowData)"
                                [pTooltip]="rowData.IsInvoiceLevel ? 'Yes' : 'No'"
                                tooltipPosition="top"
                                (onChange)="toggleInvoiceLevel(rowData)"
                            ></p-checkbox>
                        </td>
                        <td
                            [pTooltip]="rowData.StructureIsReadOnly ? 'YES' : 'NO'"
                            tooltipPosition="top"
                        >
                            {{ rowData.StructureIsReadOnly ? 'YES' : 'NO' }}
                        </td>
                        <td
                            [pTooltip]="rowData.CurrentAuthUser"
                            tooltipPosition="top"
                            [tooltipDisabled]="!rowData.CurrentAuthUser"
                        >
                            {{ rowData.CurrentAuthUser }}
                        </td>
                        <td
                            [pTooltip]="formatFirstProcessDate(rowData.FirstProcessDate)"
                            tooltipPosition="top"
                            [tooltipDisabled]="!formatFirstProcessDate(rowData.FirstProcessDate)"
                        >
                            {{ formatFirstProcessDate(rowData.FirstProcessDate) }}
                        </td>
                    </tr>
                </ng-template>
            </p-treeTable>
        </div>
        <div
            class="page-overlay"
            #tabOverlay
            id="tabOverlay"
            tabindex="0"
            style="display: none"
        ></div>
    </div>
</div>
